import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './CivicEventCard.css'

const TOPIC_META = {
  zoning:      { label: 'Zoning',       color: '#7C3AED', bg: 'rgba(124, 58, 237, 0.12)' },
  schools:     { label: 'Schools',      color: '#059669', bg: 'rgba(5, 150, 105, 0.12)'  },
  budget:      { label: 'Budget',       color: '#D97706', bg: 'rgba(217, 119, 6, 0.12)'  },
  police:      { label: 'Public Safety',color: '#DC2626', bg: 'rgba(220, 38, 38, 0.12)'  },
  environment: { label: 'Environment',  color: '#0F7490', bg: 'rgba(15, 116, 144, 0.12)' }
}

export default function CivicEventCard({ event, onDebate }) {
  const navigate = useNavigate()
  const [expanded, setExpanded] = useState(false)

  const topic = TOPIC_META[event.topic_tag] || TOPIC_META.budget
  const cityLabel = event.state ? `${event.city}, ${event.state}` : event.city

  const voteEntries = event.vote_breakdown
    ? Object.entries(event.vote_breakdown).filter(([, v]) => v > 0)
    : []

  const decisionMakers = Array.isArray(event.key_decision_makers)
    ? event.key_decision_makers.slice(0, 3)
    : []

  const handleDebate = () => {
    if (onDebate) {
      onDebate(event)
    } else {
      navigate(`/feed?civic_debate=${event.id}`)
    }
  }

  return (
    <div className="civic-card animate-slideUp">
      {/* Header */}
      <div className="civic-card-header">
        <div className="civic-card-meta">
          <span
            className="civic-topic-tag"
            style={{ color: topic.color, background: topic.bg }}
          >
            {topic.label}
          </span>
          <span className="civic-city-label">◎ {cityLabel}</span>
        </div>
        <span className="civic-card-date">
          {new Date(event.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
        </span>
      </div>

      {/* Title */}
      <div className="civic-card-title">{event.title}</div>

      {/* Summary */}
      <div className="civic-card-summary">{event.claude_summary}</div>

      {/* Why it matters */}
      <div className="civic-card-why">
        <span className="civic-card-why-label">Why it matters</span>
        <div className="civic-card-why-text">{event.why_it_matters}</div>
      </div>

      {/* Expandable details */}
      {(voteEntries.length > 0 || decisionMakers.length > 0) && (
        <button
          className="civic-card-expand-btn"
          onClick={() => setExpanded(p => !p)}
        >
          {expanded ? '▲ Less' : '▼ Vote breakdown & decision makers'}
        </button>
      )}

      {expanded && (
        <div className="civic-card-details">
          {voteEntries.length > 0 && (
            <div className="civic-vote-row">
              <span className="civic-details-label">Vote</span>
              <div className="civic-vote-counts">
                {voteEntries.map(([key, val]) => (
                  <span key={key} className={`civic-vote-chip civic-vote-${key}`}>
                    {key} {val}
                  </span>
                ))}
              </div>
            </div>
          )}
          {decisionMakers.length > 0 && (
            <div className="civic-makers-row">
              <span className="civic-details-label">Decision makers</span>
              <div className="civic-makers-list">
                {decisionMakers.map((dm, i) => (
                  <span key={i} className="civic-maker-chip">{dm}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Footer */}
      <div className="civic-card-footer">
        <a
          href={event.source_url}
          target="_blank"
          rel="noopener noreferrer"
          className="civic-source-link"
          onClick={e => e.stopPropagation()}
        >
          ↗ Source document
        </a>
        <button className="btn btn-primary civic-debate-btn" onClick={handleDebate}>
          Debate this →
        </button>
      </div>
    </div>
  )
}
